import React from 'react';
import { useTranslation } from 'react-i18next';
import PremiumFolderDisc from '@wix/da-ds/pkg/Icons/PremiumFolderDisc';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SimpleHoverPopperPopover from '../../../../Popover/Preset/SimpleHoverPopperPopover';
export var PremiumIconWithPopover = function (_a) {
    var isPaidFolder = _a.isPaidFolder, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(SimpleHoverPopperPopover, { className: className, popoverContent: isPaidFolder
            ? t('deviationview.paywall.literature.premiumFolder.tooltip')
            : t('deviationview.paywall.literature.watchersOnly.tooltip') }, isPaidFolder ? (React.createElement(PremiumFolderDisc, { size: IconSize.SMALL })) : (React.createElement(EyeDisc2, { size: IconSize.SMALL }))));
};
PremiumIconWithPopover.displayName = 'PremiumIconWithPopover';
export default PremiumIconWithPopover;
//# sourceMappingURL=PremiumIconWithPopover.js.map